import { FC } from "react";

import ClientCards from "./ClientCards";
import NoClientsAdded from "./NoClientsAdded";
import { PaginatedClients, PaginatedGroups } from "../../API";
import CircularLoading from "../../common/components/progress/CircularLoading";
import { Box } from "@mui/material";

interface IClientUploadsTabsProps {
  clients: PaginatedClients | null;
  groups: PaginatedGroups[];
  deleteGroup: (clientId: string, groupId: string) => void;
  pageLoading: boolean;
}

const ClientsUploadTabPanel: FC<IClientUploadsTabsProps> = ({
  clients,
  groups,
  deleteGroup,
  pageLoading,
}) => {
  const items = clients?.items ?? [];

  return (
    <>
      {pageLoading && (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          height="50vh"
          width="100%"
        >
          <CircularLoading />
        </Box>
      )}
      {!pageLoading && items.length === 0 && <NoClientsAdded />}
      {!pageLoading && items.length > 0 && (
        <ClientCards
          deleteGroup={deleteGroup}
          clients={items}
          groups={groups}
        />
      )}
    </>
  );
};

export default ClientsUploadTabPanel;
